import { Modal } from "antd";
import styled from "styled-components";
import theme from "../../../../../styles/defaultTheme";


export const StyledModal = styled(Modal)`
    &.modal-sm  {
        width: 680px !important;
    }

    &.modal-lg  {
      width: 1000px !important; 
    }

    & .ant-modal-content{
        border: solid 1px ${(props) => props.theme.borderWhite};
    }

    & .ant-modal-content,
    & .ant-modal-header {
        margin: auto;
        background-color: ${(props) => props.theme.white};
        border-radius: 8px;
    }

    & .ant-modal-header {
        border-bottom: none;
        padding: 24px 24px 16px 24px;
    }

    .ant-modal-title {
        font-size: ${theme.font.size24};
        font-weight: bold;
        color: ${(props) => props.theme.black};
        line-height: 32px;
    }
`;
